import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { BuyTickets, GetEventByID } from "../../../controllers/customer/EventosController"; 
import { Box, Button, Container, Divider, Fab, Grid, IconButton, MenuItem, Paper, TextField, Typography, Stepper, Step, StepLabel, Stack } from "@mui/material";
import { imagesURL, stripePromisePK } from "../../../apiRoutes/apiBase";
import QUDProgress from "../../../components/progress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faMinusCircle, faPlusCircle, faTicket } from "@fortawesome/free-solid-svg-icons";

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import UserContext from "../../../navigation/context/userContext";
import Payments from "../../../components/Payments";
import SignInModal from "../../auth/signInModal";
import ResponseComponent from "../../../components/responseComponent";
import CountdownComponent from "../../../components/CountDownComponent";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import { SeatsioSeatingChart } from '@seatsio/seatsio-react';
import ReCaptchaGoogle from "../../../components/ReCaptchaGoogle";
import ReactQuill from "react-quill";

const stripePromise = loadStripe(stripePromisePK);

export default function EventTickets() {
    const { userData } = useContext(UserContext);
    const [showModal, setShowModal] = useState(false);

    const [event, setEvent] = useState({});
    const [tickets, setTickets] = useState([]);

    const [sections, setSections] = useState([]);
    const [categories, setCategories] = useState([]);
    
    const [continuar, setContinuar] = useState(false);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [comision, setComision] = useState(0);
    const [feeSeats, setFeeSeats] = useState(0);
    const [fee, setFee] = useState(0);

    /** customer data */
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(false);
    const [lastName, setLastName] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [documentType, setDocumentType] = useState('V');
    const [document, setDocument] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [documentError, setDocumentError] = useState(false);
    const [prefix, setPrefix] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [profession, setProfession] = useState('');
    const [especialista, setEspecialista] = useState('');
    const [professionError, setProfessionError] = useState(false);

    const [activeStep, setActiveStep] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [successA, setSuccessA] = useState(false);
    const [show, setShow] = useState(false);
    const [goBack, setGoBack] = useState(false);

    const [selectedSeats, setSelectedSeats] = useState([]);
    const [holdToken, setHoldToken] = useState('');

    const [reCaptcha, setReCaptcha] = useState('');

    const { id } = useParams();
    const history = useHistory();

    const redireccionar = (route) => {
        history.push(route);
    };

    /*const options = {
        mode: 'payment',
        currency: 'usd',
        amount: 100, 
        paymentMethodTypes: ['card']
    };*/
    const options = {
        mode: 'payment',
        currency: event.financial?.base_currency ? event.financial.base_currency.toLowerCase() : 'usd',
        amount: total > 0 ? Math.round(total * 100) : 100, 
        paymentMethodTypes: ['card']
    };

    const steps = ['Selección de Boletos', 'Datos del Asistente', 'Pago y Confirmación'];

    useEffect(() => {
        handleGetEvent();
        if (userData.user !== undefined) {
            setName(userData.entity.name);
            setLastName(userData.entity.last_name);
            setDocumentType(userData.entity.document_type);
            setDocument(userData.entity.document_number);
            setPrefix(userData.user.prefijo);
            setPhoneNumber(userData.entity.phone);
            setEmail(userData.user.email);
        }
        window.scrollTo(0, 0);
        if (userData.user === undefined) setShowModal(true);
    }, []);

    const handleGetEvent = async () => {
        setIsLoading(true);
        let response = await GetEventByID(id);
        if (response.success === true) {
            setEvent(response.data.event);
            setTickets(response.data.tickets);
            handleSettingTickets(response.data.tickets);
        }
        setIsLoading(false);
    };

    const handleSettingTickets = async (_tickets) => {
        let _sections = [];
        let _categories = [];
        if (_tickets !== undefined) {
            _tickets.forEach(item => {
                _sections.push({
                    uuid: item.uuid,
                    name: item.name, 
                    description: item.description,
                    price: item.price,
                    cantidad: 0,
                    max_selection: item.max_selection,
                    lista_asientos: [],
                    capacity: item.capacity,
                    sold: item.sold,
                    available: item.available,
                    mostrar_disp: true, 
                    status: item.status
                });

                _categories.push({
                    category: item.name,
                    price: item.price,
                    description: item.description
                });
            });

            setSections(_sections);
            setCategories(_categories);
        }
    };

    const handleShoppingCart = async (_uuid, _operator, _ticket) => {
        setSections((prevSections) => {
            const updatedSections = [...prevSections];
            const indexToUpdate = updatedSections.findIndex((item) => item.uuid === _uuid);

            if (indexToUpdate !== -1) {
                let _cantidad = updatedSections[indexToUpdate].cantidad;
                
                if (_operator === '+') {
                    if (_cantidad < _ticket.available && _cantidad < _ticket.max_selection)
                        _cantidad = _cantidad + 1;
                } else {
                    if (_cantidad > 0) _cantidad = _cantidad - 1;
                }

                updatedSections[indexToUpdate].cantidad = _cantidad;
                
                let _lista_asientos = [];
                for(let i = 0; i < _cantidad; i++) {
                    _lista_asientos.push({ fil: updatedSections[indexToUpdate].name });
                }
                updatedSections[indexToUpdate].lista_asientos = _lista_asientos;
            }
            return updatedSections;
        });
    };

    const handleTotals = async () => {
        let _subtotal = 0;
        let _comision = 0;
        let _total = 0;
        let _comision_asientos = 0;

        // 🔥 CORRECCIÓN: Usamos ?? para que respete el 0 cuando venga del backend
        const feePercentage = parseFloat(event.financial?.fee_percentage ?? 0);
        const feeMinimum = parseFloat(event.financial?.fee_minimum ?? 0); 
        const feeSeatCost = parseFloat(event.financial?.fee_seats ?? 0);

        sections.forEach(item => {
            const ticketPrice = parseFloat(item.price || 0);
            _subtotal += (item.cantidad * ticketPrice);

            // Si el evento o boleto es gratuito, no calculamos comisiones
            if (ticketPrice > 0 && !event.is_free) {
                _comision_asientos += (item.cantidad * feeSeatCost);
                let comisionPorcentajeUnitaria = ticketPrice * (feePercentage / 100);
                let comisionUnitariaReal = Math.max(comisionPorcentajeUnitaria, feeMinimum);
                _comision += (comisionUnitariaReal * item.cantidad);
            }
        });

        _total = _subtotal + _comision + _comision_asientos;

        setSubTotal(_subtotal);
        setComision(_comision + _comision_asientos);
        setFee(_comision + _comision_asientos);
        setFeeSeats(_comision_asientos);
        setTotal(_total);
    };

    useEffect(() => {
        handleTotals();
        const encontrado = sections.some(section => section.cantidad > 0);
        setContinuar(encontrado);
    }, [sections]);

    const handleNext = async () => {
        if (activeStep === 1) {
            if (formVerification() === 1) return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        window.scrollTo(0, 0);
    };

    const formVerification = () => {
        let ban = 0;
        if (name === '') { setNameError(true); ban = 1; }
        if (lastName === '') { setLastNameError(true); ban = 1; }
        if (event.is_document_mandatory && document === '') { setDocumentError(true); ban = 1; }
        if (phoneNumber.length < 11) { setPhoneNumberError(true); ban = 1; }
        if (email === '') { setEmailError(true); ban = 1; }

        if (event.requires_profession && profession === '') {
            setProfessionError(true);
            ban = 1;
        }
        return ban;
    };

    const handleSubmit = async (paymentSuccess, payments, automatedPayment = false, paymentMessage = '') => {
        if (!paymentSuccess) {
            setTitle('Operación Fallida!');
            setMessage(paymentMessage);
            setSuccessA(false);
            setShow(true);
            return;
        }

        setIsLoading(true);

        const clienteObj = {
            nombre: name,
            apellido: lastName,
            documento: documentType + '-' + document, 
            correo: email,
            telefono: phoneNumber,
            profesion: event.requires_profession ? `${profession} ${especialista}` : ''
        };

        let id_usuario = userData?.user?.id || null;
        const id_comercio = event.merchant?.uuid; 
        const montoTotal = parseFloat(subtotal);

        const detalles = sections
            .filter(section => section.cantidad > 0)
            .map(section => ({
                uuid: section.uuid, 
                cantidad: section.cantidad,
                price: section.price,
                description: section.description || '',
                lista_asientos: section.lista_asientos || []
            }));

        let pagosArray = [];
        if (payments !== null) {
            pagosArray = [{
                amount: parseFloat(payments.monto),
                reference: payments.referencia,
                id_numero_cuenta: payments.id_numero_cuenta || null
            }];
        }

        try {
            let response = await BuyTickets(
                id_usuario,
                id_comercio,
                clienteObj,
                montoTotal,
                comision,
                detalles,
                pagosArray,
                automatedPayment,
                holdToken,
                selectedSeats,
                event.seatsio_key 
            );
            
            if (response.success === true) {
                setTitle('¡Operación Exitosa!');
                setMessage(response.message); 
                setSuccessA(true);
            } else {
                setTitle('Operación Fallida');
                setMessage(response.message?.message || response.message || 'Error desconocido.');
                setSuccessA(false);
            }
        } catch (error) {
            console.error("Error en handleSubmit:", error);
            setTitle('Error de Conexión');
            setMessage('No pudimos procesar tu solicitud con el servidor. Intenta nuevamente.');
            setSuccessA(false);
        }

        setShow(true);
        setIsLoading(false);
    };

    const handleOnClose = () => {
        setShowModal(false);
        if (localStorage.getItem('UserAccount') === null) {
            setSuccessA(false);
            setTitle('Inicio de sesión obligatorio');
            setMessage('Para poder comprar boletos debe registrarse y/o iniciar sesión');
            setGoBack(true);
            setShow(true);
        }
    };

    const handleClostResponse = () => {
        if (goBack === true) {
            history.goBack();
        } else {
            if (successA === true) redireccionar('/');
            else setShow(false);
        }
    };

    const handleSelectingSeat = async (selectedObject, _operator) => {
        setSections((prevSections) => {
            const updatedSections = [...prevSections];
            const indexToUpdate = updatedSections.findIndex((item) => item.name === selectedObject.category.label);
            
            if (indexToUpdate !== -1) {
                if (_operator === '+') {
                    const seats = updatedSections[indexToUpdate].lista_asientos;
                    if (selectedObject.seats) {
                        selectedObject.seats.forEach(item => {
                            const [label, fil, col] = item.label.split('-');
                            const seatFound = seats.find(seat => seat.fil === fil && seat.col === col);
                            if (!seatFound) updatedSections[indexToUpdate].lista_asientos.push({ fil, col });
                        });
                    } else {
                        const seatFound = seats.find(seat => seat.fil === selectedObject.labels.parent && seat.col === selectedObject.labels.own);
                        if (!seatFound) updatedSections[indexToUpdate].lista_asientos.push({ fil: selectedObject.labels.parent, col: selectedObject.labels.own });
                    }
                    updatedSections[indexToUpdate].cantidad = updatedSections[indexToUpdate].lista_asientos.length;
                } else {
                    if (selectedObject.seats) {
                        selectedObject.seats.forEach(item => {
                            const [label, fil, col] = item.label.split('-');
                            updatedSections[indexToUpdate].lista_asientos = updatedSections[indexToUpdate].lista_asientos.filter(seat => !(seat.fil === fil && seat.col === col));
                        });
                    } else {
                        updatedSections[indexToUpdate].lista_asientos = updatedSections[indexToUpdate].lista_asientos.filter(seat => !(seat.fil === selectedObject.labels.parent && seat.col === selectedObject.labels.own));
                    }
                    updatedSections[indexToUpdate].cantidad = updatedSections[indexToUpdate].lista_asientos.length;   
                }
            }
            return updatedSections;
        });
    };

    const handleGoBack = () => {
        if (activeStep === 1) handleSettingTickets(tickets);
        setActiveStep(activeStep - 1);
    };

    // 👇 Helper para manejar las URLs de imágenes y evitar que se rompan
    const getImageUrl = (imagePath) => {
        if (!imagePath) return '';
        return imagePath.startsWith('http') ? imagePath : `${imagesURL}eventos/${imagePath}`;
    };

    const eventCoverUrl = getImageUrl(event.header_image);
    const eventPosterUrl = getImageUrl(event.image);

    return (
        // 👇 SOLUCIÓN 1: Eliminamos mt={-5} y agregamos pt={3} para que el navbar no tape la cabecera
        <Box sx={{ bgcolor: '#fafafa', minHeight: '100vh', pt: { xs: 2, md: 4 }, pb: 10 }}>
            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={show}
                success={successA}
                title={title}
                message={message}
                actionText={'Aceptar'}
                onClick={() => handleClostResponse()}
            />

            {/* Cabecera Estilo Premium */}
            <Box sx={{ position: 'relative', width: '100%', mb: 4, bgcolor: '#1a1a1a', overflow: 'hidden', borderRadius: { xs: 0, md: 4 }, mx: { xs: 0, md: 'auto' }, maxWidth: { md: '95%' } }}>
                {event.header_image ? (
                    <>
                        <Box
                            sx={{
                                backgroundImage: `url(${eventCoverUrl})`,
                                backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(30px) brightness(0.4)',
                                transform: 'scale(1.1)', height: { xs: 150, md: 220 }, width: '100%', position: 'absolute', zIndex: 0
                            }}
                        />
                        <Container sx={{ position: 'relative', zIndex: 1, height: { xs: 150, md: 220 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src={eventCoverUrl} alt={event.name} style={{ maxHeight: '80%', maxWidth: '100%', objectFit: 'contain' }} />
                        </Container>
                    </>
                ) : (
                    <Box sx={{ width: '100%', height: { xs: 150, md: 200 }, display: 'flex', flexDirection: 'column', bgcolor: 'primary.main', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant='h5' color={'primary.contrastText'} fontWeight={'bold'} textAlign={'center'}>{event.name}</Typography>
                        <Typography variant='body1' color={'primary.contrastText'} sx={{ opacity: 0.8 }}>{event.city}</Typography>
                    </Box>
                )}
            </Box>
            
            <Container maxWidth="lg">
                <Grid container spacing={5}>
                    {/* 👇 SOLUCIÓN 2: Ocultamos la columna izquierda en móviles (display: { xs: 'none', md: 'block' }) */}
                    <Grid item xs={12} md={4} lg={4} sx={{ display: { xs: 'none', md: 'block' } }}>
                        <Paper elevation={12} sx={{ borderRadius: 4, overflow: 'hidden', position: 'sticky', top: 20 }}>
                            {/* 👇 SOLUCIÓN 3: Usamos eventPosterUrl arreglado */}
                            <img style={{ width: '100%', display: 'block' }} src={eventPosterUrl} alt={event.name} />
                            
                            <Box p={3} bgcolor="#fff">
                                <Typography variant="h6" fontWeight="bold" mb={2}>Resumen</Typography>
                                <CountdownComponent refreshTime={600000} />
                                
                                {subtotal > 0 && (
                                    <Box mt={2} pt={2} borderTop="1px dashed #e0e0e0">
                                        <Typography variant="body2" color="text.secondary">Total a pagar:</Typography>
                                        <Typography variant="h5" color="primary" fontWeight="bold">{total.toFixed(2)} {event.financial?.base_currency || 'USD'}</Typography>
                                    </Box>
                                )}
                            </Box>
                        </Paper>
                    </Grid>
                    
                    {/* Columna Derecha: Flujo de Compra */}
                    <Grid item xs={12} md={8} lg={8}>
                        
                        <Stack direction="row" alignItems="center" spacing={2} mb={3}>
                            {activeStep > 0 && (
                                <IconButton onClick={() => handleGoBack()} sx={{ bgcolor: 'rgba(0,0,0,0.05)' }}>
                                    <FontAwesomeIcon icon={faArrowLeft} size="sm" />
                                </IconButton>
                            )}
                            <Typography variant="h4" fontWeight={'800'}>{event.name}</Typography>
                        </Stack>

                        <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 4, bgcolor: '#ffffff' }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Paper>
                        
                        {/* PASO 0: SELECCIÓN DE BOLETOS */}
                        {activeStep === 0 && (
                            <Box animation="fadeIn">
                                <SignInModal open={showModal} onClose={() => handleOnClose()}/>
                                {event.seatsio_key && categories.length !== 0 ? (
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" fontWeight="bold" mb={2}>Selecciona tus asientos</Typography>
                                            <Paper variant="outlined" sx={{ width: '100%', height: 500, borderRadius: 4, overflow: 'hidden' }}>
                                                <SeatsioSeatingChart
                                                    workspaceKey="f0117c1e-e399-4ff5-93c2-ee4219d608f5"
                                                    event={event.seatsio_key}
                                                    region="sa"
                                                    pricing={categories}
                                                    priceFormatter={price => '€' + price}
                                                    tooltipInfo={(object) => {
                                                        const category = categories.find(item => item.category === object.label);
                                                        return category ? category.description : '';
                                                    }}
                                                    onObjectSelected={(selectedObject) => {
                                                        handleSelectingSeat(selectedObject, '+');
                                                        setSelectedSeats(selectedObject.chart.selectedSeats);
                                                        setHoldToken(selectedObject.chart.holdToken);
                                                    }}
                                                    onObjectDeselected={(selectableObject) => { handleSelectingSeat(selectableObject, '-'); }}
                                                    session="continue"
                                                />
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <>
                                        <Typography variant="h6" fontWeight="bold" mb={2}>Tipos de Boletos</Typography>
                                        <Stack spacing={2}>
                                            {sections
                                                .filter(item => parseInt(item.status) === 1) 
                                                .map((item) => (
                                                    <Paper 
                                                        key={item.uuid} 
                                                        variant="outlined"
                                                        sx={{ 
                                                            p: 3,
                                                            borderRadius: 4,
                                                            transition: 'all 0.2s ease-in-out',
                                                            borderColor: item.cantidad > 0 ? 'primary.main' : '#e0e0e0', 
                                                            bgcolor: item.cantidad > 0 ? 'rgba(0, 118, 255, 0.03)' : '#FFF',
                                                            boxShadow: item.cantidad > 0 ? '0 4px 20px rgba(0, 118, 255, 0.1)' : 'none'
                                                        }}
                                                    >
                                                        <Grid container spacing={3} alignItems="center">
                                                            <Grid item xs={12} sm={7}>
                                                                <Typography variant="h6" fontWeight="bold" color="text.primary">{item.name}</Typography>
                                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{item.description}</Typography>
                                                                <Typography variant="h6" fontWeight="bold" color="primary.main">
                                                                    {item.price} {event.financial?.base_currency || 'USD'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={5}>
                                                                {item.sold < item.capacity ? (
                                                                    <Box display="flex" flexDirection="column" alignItems={{ xs: 'flex-start', sm: 'flex-end' }}>
                                                                        <Box display="flex" alignItems="center" bgcolor="#f5f5f5" borderRadius={8} p={0.5}>
                                                                            <IconButton color={item.cantidad > 0 ? 'primary' : 'default'} onClick={() => handleShoppingCart(item.uuid, '-', item)}>
                                                                                <FontAwesomeIcon icon={faMinusCircle}/>
                                                                            </IconButton>
                                                                            <Typography variant="h5" fontWeight="bold" sx={{ minWidth: 40, textAlign: 'center' }}>{item.cantidad}</Typography>
                                                                            <IconButton color="primary" onClick={() => handleShoppingCart(item.uuid, '+', item)}>
                                                                                <FontAwesomeIcon icon={faPlusCircle}/>
                                                                            </IconButton>
                                                                        </Box>
                                                                        {item.mostrar_disp && (
                                                                            <Typography variant="caption" color="text.secondary" fontWeight="bold" mt={1}>
                                                                                Quedan {item.available} disp.
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                ) : (
                                                                    <Typography variant="h6" color="error.main" textAlign={{ xs: 'left', sm: 'right' }} fontWeight="bold">
                                                                        Agotado
                                                                    </Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                            ))}
                                        </Stack>
                                    </>
                                )}
                                
                                {continuar && (
                                    <Box mt={4} display="flex" justifyContent="flex-end">
                                        <Button variant="contained" size="large" sx={{ borderRadius: 8, px: 6, py: 1.5, fontWeight: 'bold', width: { xs: '100%', sm: 'auto' } }} onClick={() => handleNext()}>
                                            Continuar con mis datos
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {/* PASO 1: DATOS PERSONALES */}
                        {activeStep === 1 && (
                            <Paper variant="outlined" sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, bgcolor: '#ffffff' }}>
                                <Typography variant='h6' fontWeight="bold" mb={3}>Información del asistente principal</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth variant="outlined" label="Nombre" value={name} onChange={(e) => setName(e.target.value)} onBlur={() => setNameError(name === '')} error={nameError} helperText={nameError && 'Ingrese el nombre'} />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField fullWidth variant="outlined" label="Apellido" value={lastName} onChange={(e) => setLastName(e.target.value)} onBlur={() => setLastNameError(lastName === '')} error={lastNameError} helperText={lastNameError && 'Ingrese el apellido'} />
                                    </Grid>
                                    
                                    {event.is_document_mandatory && (
                                        <>
                                            <Grid item xs={4}>
                                                <TextField fullWidth variant="outlined" label="Tipo" select value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
                                                    <MenuItem value='V'>V</MenuItem><MenuItem value='E'>E</MenuItem><MenuItem value='P'>P</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField fullWidth variant="outlined" label="Número de documento" value={document} onChange={(e) => setDocument(e.target.value)} onBlur={() => setDocumentError(document === '')} error={documentError} helperText={documentError && 'Ingrese el número de documento'} />
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={12}>
                                        <Box sx={{ '& .react-tel-input .form-control': { width: '100%', height: '56px', borderRadius: '4px', borderColor: phoneNumberError ? '#d32f2f' : '#c4c4c4' } }}>
                                            <PhoneInput country={event.country_code?.toLowerCase() || 've'} specialLabel="Número de Teléfono" value={phoneNumber} onChange={(e) => setPhoneNumber(e)} onBlur={() => setPhoneNumberError(phoneNumber.length < 11)} />
                                        </Box>
                                        {phoneNumberError && <Typography variant="caption" color={'error.main'} mt={0.5} display="block">El número de teléfono es inválido</Typography>}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField fullWidth variant="outlined" label="Correo electrónico" type="email" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={() => setEmailError(email === '')} error={emailError} helperText={emailError && 'Ingrese un correo electrónico válido'} />
                                    </Grid>
                                    
                                    {event.requires_profession && (
                                        <>
                                            <Grid item xs={12} mt={2}>
                                                <Typography variant="subtitle2" color="text.secondary" mb={1}>Datos Profesionales (Requerido por el organizador)</Typography>
                                                <TextField fullWidth variant="outlined" label="Nivel Profesional" select value={profession} onChange={(e) => setProfession(e.target.value)} onBlur={() => setProfessionError(profession === '')} error={professionError} helperText={professionError && 'Seleccione su nivel profesional'}>
                                                    <MenuItem value='Médico General'>Médico General</MenuItem>
                                                    <MenuItem value='Médico Especialista - '>Médico Especialista</MenuItem>
                                                    <MenuItem value='Médico Residente'>Médico Residente</MenuItem>
                                                    <MenuItem value='Estudiante'>Estudiante</MenuItem>
                                                    <MenuItem value='Otro - '>Otro</MenuItem>
                                                </TextField>
                                            </Grid>
                                            {(profession === "Médico Especialista - " || profession === "Otro - ") && (
                                                <Grid item xs={12}>
                                                    <TextField fullWidth variant="outlined" label="Especialidad u otra profesión" value={especialista} onChange={(e) => setEspecialista(e.target.value)} />
                                                </Grid>
                                            )}
                                        </>
                                    )}

                                    {event.custom_terms && (
                                        <Grid item xs={12} mt={2}>
                                            <Paper variant="outlined" sx={{ p: 2, bgcolor: '#f9f9f9', borderRadius: 2 }}>
                                                <Typography fontWeight={'bold'} variant="subtitle2" mb={1}>Términos y Condiciones del Organizador</Typography>
                                                <Box sx={{ maxHeight: 150, overflowY: 'auto', fontSize: '0.85rem', color: 'text.secondary' }}>
                                                    <ReactQuill 
                                                        theme={'bubble'} 
                                                        readOnly={true} 
                                                        value={event.custom_terms}
                                                    />
                                                </Box>
                                            </Paper>
                                            <Typography variant="caption" color="text.secondary" mt={1} display="block">
                                                Al hacer clic en "Continuar a Pago", confirmas que aceptas estos términos.
                                            </Typography>
                                        </Grid>
                                    )}

                                    <Grid item xs={12} display="flex" justifyContent="center" mt={2}>
                                        <ReCaptchaGoogle onChange={setReCaptcha} onAbort={() => setReCaptcha('')} onExpired={() => setReCaptcha('')} />
                                    </Grid>

                                    <Grid item xs={12} display="flex" justifyContent="flex-end" mt={2}>
                                        <Button disabled={reCaptcha === ''} size="large" variant="contained" sx={{ borderRadius: 8, px: 6, py: 1.5, fontWeight: 'bold', width: { xs: '100%', sm: 'auto' } }} onClick={() => handleNext()}>
                                            Continuar a Pago
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                        )}

                        {/* PASO 2: CHECKOUT / PAGOS */}
                        {activeStep === 2 && (
                            <Box animation="fadeIn">
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Paper variant="outlined" sx={{ borderRadius: 4, overflow: 'hidden' }}>
                                            <Box color="black" p={2} textAlign="center">
                                                <Typography fontWeight={'bold'} variant="h6">Resumen de tu Orden</Typography>
                                            </Box>
                                            <Box p={1}> 
                                                {sections.filter(item => item.cantidad > 0).map((item, idx) => (
                                                    <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                                                        <Typography variant="body1" fontWeight="500">{item.cantidad}x {item.name}</Typography>
                                                        <Typography variant="body1">{(item.cantidad * item.price).toFixed(2)}</Typography>
                                                    </Box>
                                                ))}
                                                
                                                <Divider sx={{ my: 2, borderStyle: 'dashed' }}/>
                                                
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: 'text.secondary' }}>
                                                    <Typography variant="body2">Subtotal</Typography>
                                                    <Typography variant="body2">{subtotal.toFixed(2)}</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', color: 'text.secondary' }}>
                                                    <Typography variant="body2">Service Fee (QUD)</Typography>
                                                    <Typography variant="body2">{fee.toFixed(2)}</Typography>
                                                </Box>
                                                
                                                <Box sx={{ bgcolor: '#f5f5f5', p: 2, mt: 3, borderRadius: 2 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Typography variant="h6" fontWeight="bold">Total a pagar</Typography>
                                                        <Typography variant="h5" fontWeight="900" color="primary.main">
                                                            {total.toFixed(2)} <Typography component="span" variant="h6">{event.financial?.base_currency || 'USD'}</Typography>
                                                        </Typography>
                                                    </Box>

                                                    {event.financial?.local_currency === 'VES' && event.financial?.exchange_rate > 1 && (
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1, pt: 1, borderTop: '1px solid #e0e0e0' }}>
                                                            <Typography variant="caption" color="text.secondary">Tasa referencial BCV: {event.financial.exchange_rate}</Typography>
                                                            <Typography variant="caption" color="text.secondary" fontWeight="bold">
                                                                Aprox. {(total * event.financial.exchange_rate).toFixed(2)} VES
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    {total > 0 ? (
                                        <Grid item xs={12}>
                                            <Paper variant="outlined" sx={{ p: { xs: 2, md: 4 }, borderRadius: 4 }}>
                                                <Typography variant="h6" fontWeight="bold" mb={3}>Método de Pago</Typography>
                                                <Elements stripe={stripePromise} options={options}>
                                                    <Payments
                                                        merchantUUID={event.merchant?.uuid}
                                                        event_id={event.id}
                                                        country={event.country_code || 'VE'}
                                                        title={`Entradas ${event.name}`}
                                                        customer={{
                                                            nombre: name,
                                                            apellido: lastName,
                                                            documento_tipo: documentType,
                                                            documento: document,
                                                            correo: email,
                                                            prefijo: prefix,
                                                            telefono: phoneNumber,
                                                            profesion: profession
                                                        }}
                                                        amount={parseFloat(total.toFixed(2))}
                                                        exchangeRate={event.financial?.exchange_rate}
                                                        currency={event.financial?.base_currency}
                                                        handleSubmit={handleSubmit}
                                                        action="Pagar y Confirmar Orden"
                                                    />
                                                </Elements>
                                            </Paper>
                                        </Grid>
                                    ) : (
                                        <Grid item xs={12} display="flex" justifyContent="center" mt={2}>
                                            <Button variant="contained" size="large" sx={{ borderRadius: 8, px: 6, py: 2, fontSize: '1.1rem', width: { xs: '100%', sm: 'auto' } }} onClick={() => handleSubmit(true, null, true)}>
                                                Generar Entradas Gratuitas
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Container>

            {/* Fab flotante para móviles */}
            {continuar && activeStep === 0 && (
                <Box onClick={() => handleNext()} role="presentation" sx={{ position: 'fixed', bottom: 24, right: 24, display: { md: 'none' }, zIndex: 10 }}>
                    <Fab variant="extended" color="primary" sx={{ px: 3, fontWeight: 'bold', boxShadow: '0 8px 20px rgba(0,118,255,0.4)' }}>
                        <Typography variant="button" sx={{ mr: 1, fontWeight: 'bold' }}>Siguiente</Typography>
                        <FontAwesomeIcon icon={faArrowLeft} style={{ transform: 'rotate(180deg)' }} />
                    </Fab>
                </Box>
            )}
        </Box>
    );
}